module.exports = __webpack_public_path__ + "img/2012_L.6a9ce5ab.png";